import { palette as paletteDefault } from './light';

export const palette = paletteDefault;
